import React from 'react';
import styled from 'styled-components';

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
`;

const CardGrid = ({ children }) => (
  <Grid>{children}</Grid>
);

export default CardGrid;